import {combineReducers} from 'redux'
import {routerReducer} from 'react-router-redux'
import { reducer as form } from 'redux-form'
import session from './session'
import modals from './modals'
import user from './user'
import signinMethods from './signinMethods'
import sections from './sections'
import archivedSections from './archivedSections'
import recentActivities from './recentActivities'
import questions from './library/questions'
import questionsRefreshedTimestamp from './library/questionsRefreshedTimestamp'
import sets from './library/sets'
import setsRefreshedTimestamp from './library/setsRefreshedTimestamp'
import archivedQuestions from './library/archivedQuestions'
import folders from './library/folders'
import archivedFolders from './library/archivedFolders'
import archivedSets from './library/archivedSets'
import questionPollsRefreshedTimestamp from './polls/questionPollsRefreshedTimestamp'
import setPollsRefreshedTimestamp from './polls/setPollsRefreshedTimestamp'
import queueQuestionPolls from './polls/queue/queueQuestionPolls'
import queueSetPolls from './polls/queue/queueSetPolls'
import historyQuestionPolls from './polls/history/historyQuestionPolls'
import historySetPolls from './polls/history/historySetPolls'
import control from './control'
import sectionControls from './sectionControls'
import pusherPoll from './polls/pusherPoll'
import meta from './meta'
import notification from './notification'
import liveViewNotification from './liveViewNotification'
import service from './service'
import planRestrictions from './planRestrictions'
import billing from './billing'
import invoices from './invoices'
import clockSyncOffset from './clockSyncOffset'
import geoInfo from './geoInfo'
import scoreSheetCustomDateRange from './scoreSheetCustomDateRange'
import mobileInfo from './mobileInfo'
import upcomingInvoice from './upcomingInvoice'
import onboardingWizardDismissed from './onboardingWizardDismissed'
import repos from './repos'
import permissions from './permissions'
import locks from './locks'
import searchKey from './searchKey'
import setsPreview from './library/setsPreview'
import questionsPreview from './library/questionsPreview'
import foldersPreview from './library/foldersPreview'
import discounts from './discounts'
import backToSchoolModal from './backToSchoolModal'



const rootReducer = combineReducers({
	service,
	backToSchoolModal,
	setsPreview,
	questionsPreview,
	foldersPreview,
	locks,
	searchKey,
	repos,
	permissions,
	discounts,
	upcomingInvoice,
	clockSyncOffset,
	mobileInfo,
	billing,
	invoices,
	planRestrictions,
	scoreSheetCustomDateRange,
	liveViewNotification,
	questionPollsRefreshedTimestamp,
	setPollsRefreshedTimestamp,
	notification,
	meta,
	sectionControls,
	signinMethods,
	archivedSections,
	folders,
	archivedFolders,
	sets,
	setsRefreshedTimestamp,
	archivedSets,
	questions,
	questionsRefreshedTimestamp,
	archivedQuestions,
	queueQuestionPolls,
	queueSetPolls,
	historyQuestionPolls,
	historySetPolls,
	control,
	pusherPoll,
	geoInfo,
	onboardingWizardDismissed,
	session,
	form,
	user,
	sections,
	modals,
	recentActivities,
	routing:routerReducer})

export default rootReducer


// WEBPACK FOOTER //
// ./src/reducers/index.js